import React, { PropsWithChildren } from "react";
import { Provider } from "react-redux";

interface SharedProviderProps {
  store: any;
}

export const SharedProvider = ({
  store,
  children,
}: PropsWithChildren<SharedProviderProps>) => {
  return <Provider store={store}>{children}</Provider>;
};
